module.exports = __webpack_public_path__ + "static/media/LK_Eye Open.96f47978.svg";